var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "project-card",
    class: {
      inactive: _vm.isInactive
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('transaction-browsing', _vm.project);
      }
    }
  }, [_c('div', {
    staticClass: "project-main"
  }, [_c('div', {
    staticClass: "project-logo"
  }, [_c('project-logo', {
    attrs: {
      "project": _vm.project,
      "size": "lg"
    }
  })], 1), _c('div', {
    staticClass: "project-name",
    attrs: {
      "title": _vm.project.name
    }
  }, [_vm._v(_vm._s(_vm.project.name))]), _c('a', {
    staticClass: "project-link",
    attrs: {
      "href": _vm.project.link,
      "target": "_blank"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.formattedLink))]), _c('project-control-icons', {
    attrs: {
      "permission": _vm.transactionsBrowsingPermission,
      "pending": _vm.isPendingBrowsingPermission
    },
    on: {
      "disable": function disable($event) {
        return _vm.$emit('disable-project', _vm.project);
      }
    }
  })], 1), _c('div', {
    staticClass: "project-info"
  }, [_c('div', {
    staticClass: "project-info-point"
  }, [_c('span', {
    staticClass: "project-info-name"
  }, [_vm._v(_vm._s(_vm.$t('common.balance')))]), _c('span', {
    staticClass: "project-info-price"
  }, [_vm._v(_vm._s(_vm.displayBalance))])]), _c('div', {
    staticClass: "project-info-point"
  }, [_c('span', {
    staticClass: "project-info-name"
  }, [_vm._v(_vm._s(_vm.$t('average.check')))]), _c('span', {
    staticClass: "project-info-price"
  }, [_vm._v(_vm._s(_vm.displayAvgAmount))])]), _c('div', {
    staticClass: "project-info-point"
  }, [_c('span', {
    staticClass: "project-info-name"
  }, [_vm._v(_vm._s(_vm.$t('payments.in.day')))]), _c('span', {
    staticClass: "project-info-price"
  }, [_vm._v(_vm._s(_vm.project.paymentsPerDay))])]), _c('div', {
    staticClass: "project-info-point"
  }, [_c('span', {
    staticClass: "project-info-name"
  }, [_vm._v(_vm._s(_vm.$t('common.transactions')))]), _vm.isPendingBrowsingPermission ? _c('card-tooltip', {
    attrs: {
      "width": 200
    }
  }, [_c('span', {
    attrs: {
      "slot": "trigger",
      "data-browsing-permission": _vm.browsingPermissionAttribute
    },
    slot: "trigger"
  }, [_vm._v(" " + _vm._s(_vm.displayBrowsingPermission) + " ")]), _vm._v(" " + _vm._s(_vm.displayWaitingTime) + " ")]) : _c('span', {
    attrs: {
      "data-browsing-permission": _vm.browsingPermissionAttribute
    }
  }, [_vm._v(" " + _vm._s(_vm.displayBrowsingPermission) + " ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }